import React, { useState, useEffect } from 'react'
import PropTypes from "prop-types"
import _ from 'lodash'
import Moment from 'moment'
import { extendMoment } from 'moment-range';
import { useTextResources } from '../../../language';
const moment = extendMoment(Moment);
import { Checkbox, Grid } from 'semantic-ui-react'
const weekdays = ["SelectDay_Sun", "SelectDay_Mon", "SelectDay_Tue", "SelectDay_Wed", "SelectDay_Thu", "SelectDay_Fri", "SelectDay_Sat"]
const allDays = [0, 1, 2, 3, 4, 5, 6]
const WeekDaysSelect = ({ onChange, dates, initDays, useWithoutDates, ...rest }) => {
    const text = useTextResources()
    const [days, setDays] = useState(initDays || allDays);
    const [usedInitDays, setUsedInitDays] = useState(false);
    const [daysInRange, setDaysInRange] = useState(useWithoutDates ? allDays : [])
    useEffect(() => {
        let newDays = []
        if (dates?.length > 0) {
            dates.forEach((date) => {
                if (!date.startDate || !date.endDate) return;
                let range = moment.range(moment(date.startDate).startOf('day'), moment(date.endDate).startOf('day'));
                newDays.push(...Array.from(range.by("day")).map(d => d.weekday()))
            })
            newDays = _.uniq(newDays);
            setDaysInRange(useWithoutDates ? allDays : newDays);
        }
        if (useWithoutDates) {
            newDays = allDays;
        }

        setDaysInRange(newDays);

        if (!useWithoutDates) {
            if (initDays?.length > 0 && !usedInitDays) {
                setDays(initDays);
                setUsedInitDays(true);
            } else {
                setDays(newDays);
            }
        }
    }, [dates])

    useEffect(() => {
        if (days)
            onChange?.(days);
    }, [days])

    const handleWeekdayCheck = (index, checked) => {
        const newDays = checked ? _.union(days, [index]) : _.xor(days, [index])
        setDays(newDays)
    }

    const handleAllCheck = (checked) => {
        const newDays = checked ? allDays : []
        setDays(newDays);
    }

    return (
        <Grid textAlign="center" columns='equal' {...rest}>
            {
                _.map(weekdays, (weekday, index) => {
                    return (
                        <Grid.Column key={weekday}>
                            <div>{text(weekday)}</div>
                            <Checkbox checked={_.includes(days, index)} disabled={!_.includes(daysInRange, index)} onChange={(e, { checked }) => handleWeekdayCheck(index, checked)}></Checkbox>
                        </Grid.Column>
                    )
                })
            }
            <Grid.Column>
                <div>{text("All")}</div>
                <Checkbox checked={_.isEmpty(_.xor(allDays, days))} disabled={daysInRange.length < 7} onChange={(e, { checked }) => handleAllCheck(checked)}></Checkbox>
            </Grid.Column>
        </Grid>
    )
}
WeekDaysSelect.propTypes = {
    onChange: PropTypes.func,
    dates: PropTypes.array,
    initDays: PropTypes.array,
    useWithoutDates: PropTypes.bool
}
export default WeekDaysSelect
